import { findIndex } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import './SelectableGrid.scss';

import OptionBtn from './OptionBtn';

class SingleSelectionGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: props.selectedOptions ? props.selectedOptions : [],
    };
  }

  componentDidUpdate() {
    const { onSelect } = this.props;
    const { selected } = this.state;

    if (onSelect) {
      onSelect(selected);
    }
  }

  selectOption(selectedOption) {
    this.setState({
      selected: [selectedOption],
    });
  }

  isSelected(option) {
    const { selected } = this.state;
    return findIndex(selected, option) > -1;
  }

  render() {
    const { phoneColNum, title, options, btnSize, footer, limitText } =
      this.props;
    return (
      <div>
        <div className="selectable-grid-title">{title}</div>
        <div className="selectable-grid-limit-text">{limitText}</div>
        <div className="selectable-grid-options-container">
          {options.map((option, i) => {
            return (
              <OptionBtn
                id={`${i}`}
                option={option}
                key={i}
                phoneColNum={phoneColNum}
                size={btnSize + 'px'}
                onClick={() => this.selectOption(option)}
                selected={this.isSelected(option)}
                disabled={false}
              >
                {option.label}
              </OptionBtn>
            );
          })}
        </div>
        <div className="selectable-grid-footer-container">{footer}</div>
      </div>
    );
  }
}

SingleSelectionGrid.defaultProps = {
  btnSize: 35,
};

SingleSelectionGrid.propTypes = {
  btnSize: PropTypes.number,
  footer: PropTypes.any,
  id: PropTypes.string.isRequired,
  limitText: PropTypes.string,
  onSelect: PropTypes.func,
  optionName: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    })
  ).isRequired,
  phoneColNum: PropTypes.number,
};

export default SingleSelectionGrid;
